import { Message, MessageBox } from 'element-ui';
import { requestExportComplianceDetection } from '@/API';

const compact = values => [...new Set(values
  .flat(Infinity)
  .map(value => String(value || '').trim())
  .filter(Boolean))];

const pick = (source, keys) => keys.map(key => {
  return key.split('.').reduce((value, name) => value && value[name], source);
});

const buildAddress = address => compact([
  address && [address.province, address.city, address.county, address.receiptAddress].join('')
]);

const riskMessage = result => result.detailMsg || result.resultMsg ||
  result.overallConclusion || '出口合规检测未通过';

export const buildPartialShipmentComplianceRequest = ({
  businessScene,
  originalBizId,
  contractInfo = {},
  address,
  addresses = [],
  products = [],
  projectName
}) => {
  const subjectNameList = compact([
    pick(contractInfo, [
      'orderUnit',
      'finalCustomer',
      'extContractData.frameworkAgreementName',
      'frameworkAgreementName',
      'integratorName',
      'measureIntegratorName',
      'metrologyIntegratorName',
      'finalIntegratorsName',
      'finalIntegratorName',
      'classAProductProviderName',
      'classBProductProviderName',
      'classCProductProviderName',
      'aProductServiceProvider',
      'bProductServiceProvider',
      'cProductServiceProvider',
      'serviceSubjectName'
    ]),
    address && address.receiverUnit,
    addresses.map(item => item && item.receiverUnit)
  ]);
  const addressList = compact([
    buildAddress(address),
    addresses.map(buildAddress),
    products.map(item => item.deliveryAddress)
  ]);
  const request = {
    businessScene,
    originalBizId: originalBizId && String(originalBizId),
    subjectNameList,
    addressList,
    itemModelList: compact(products.map(item => item.productName)),
    itemPartNumberList: compact(products.map(item => item.materialNumber)),
    projectName: projectName || contractInfo.projectName || contractInfo.masterProjectName
  };
  Object.keys(request).forEach(key => {
    if (request[key] === '' || request[key] == null || (Array.isArray(request[key]) && !request[key].length)) {
      delete request[key];
    }
  });
  return request;
};

export const checkPartialShipmentCompliance = async options => {
  const response = await requestExportComplianceDetection(buildPartialShipmentComplianceRequest(options));
  const { status, data, err } = response.data;
  if (status !== '200' || !data || data.overallRiskLevel == null) {
    throw new Error(err || '出口合规检测失败');
  }
  if (data.overallRiskLevel >= 3) {
    Message.error(riskMessage(data));
    return false;
  }
  if (data.overallRiskLevel === 2) {
    try {
      await MessageBox.confirm(riskMessage(data), '出口合规风险提示', {
        confirmButtonText: '继续提交',
        cancelButtonText: '取消',
        type: 'warning'
      });
    } catch (error) {
      return false;
    }
  }
  return true;
};
